import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInboxChecked: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="inbox-checked, saved"><path d="M7.25 10.4878L10.925 14.25L17.75 4.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 14.75V20.25H20.25V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconInboxChecked;
